import { CirclesError } from './circles-error';

export class InvalidAccessTokenError extends CirclesError {
	constructor() {
		super('The access token is invalid or blank.');
	}
}
